// eslint-disable-next-line no-unused-vars
function getUserOperatingSystem() {
  let userAgent = navigator.userAgent || navigator.vendor || window.opera;

  // Windows Phone must come first because its UA also contains "Android"
  if (/windows phone/i.test(userAgent)) {
    return "unknown";
  }

  if (/android/i.test(userAgent)) {
    return "Android";
  }

  // iOS detection from: http://stackoverflow.com/a/9039885/177710
  if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
    return "iOS";
  }

  return "unknown";
}

const searchModal = {
  attachListeners: function () {
    this.modalSearchOpen();
    this.modalSearchClose();
    this.modalSearchInputFocus();
    this.modalSearchInputFocusOut();
    this.modalSearchInput();
    this.modalSearchInputClear();
    this.modalSearchEnter();
    this.modalSearchEnterMobile();
    this.modalSearchEsc();
  },

  init: function () {
    document.addEventListener("DOMContentLoaded", () => {
      this.attachListeners();
    });
  },

  modalSearchOpen: function () {
    $(".js-btn-search, .js-btn-search-mobile").on("click", function () {
      $("#modal-search").removeClass("d-none").addClass("d-block is-visible");
      window.scrollTo(0, 0);
      $(".search-input").val("");
      $("body").addClass("overflow-hidden");
    });
  },
  modalSearchClose: function () {
    $(".js-btn-search-close").on("click", function () {
      $("#modal-search").removeClass("d-block").addClass("d-none");
      $("body").removeClass("overflow-hidden");
    });
  },
  modalSearchInputFocus: function () {
    $(".search-input").on("focus", function () {
      $(".suggerimenti").removeClass("d-none");
    });
  },
  modalSearchInputFocusOut: function () {
    $(".search-input").on("focusout", function () {
      $(".suggerimenti").addClass("d-none");
    });
  },
  modalSearchInputClear: function () {
    $(".js-btn-input-clear").on("click", function () {
      $(".search-input").val("");
      $(".js-btn-input-clear").addClass("d-none");
      $(".search-input-wrapper img").removeClass("d-none");
    });
  },
  modalSearchInput: function () {
    $(".search-input").on("input", function () {
      if ($(window).width() > 900) {
        if ($(".search-input").val() == "") {
          $(".js-btn-input-clear").addClass("d-none");
        } else {
          $(".js-btn-input-clear").removeClass("d-none");
        }
      }
    });
  },
  modalSearchEnter: function () {
    $(".search-input").keydown(function (e) {
      if (e.keyCode == 13) {
        $("#search-form .js-btn-input-clear").addClass("d-none");
        $("#search-form .spinner-border").removeClass("d-none");
        $("#search-form").submit();
      }
    });
  },
  modalSearchEnterMobile: function () {
    $(".search-input-wrapper img").on("click", function () {
      $("#search-form").submit();
    });
  },
  modalSearchEsc: function () {
    $(document).on("keyup", function (e) {
      if (e.key == "Escape") {
        $(".js-btn-search-close").trigger("click");
      }
    });
  },
};

window.searchModal = searchModal;
window.searchModal.init();
